export default {
  emoji_picker_button_tooltip: 'Add an emoji/sticker',
};
